module.exports = __webpack_public_path__ + "img/shareBackground.05475aa0.jpg";